import React, { useEffect } from "react";
import OTPVerify from "../newProviderApp/component/shared/otp";
import TitleHeader from "../newProviderApp/component/titleHeader";
import Button from "../newProviderApp/component/button";
import { ShowAlert } from "../../common/alert";
import axios from "axios";
import TemplateComp from "../contentReaderMarkdown/templateComp";
import LinkExpire from "../contentReaderMarkdown/linkExpire";
import SharedCodeViewer from "./sharedCodeViewer";

const CodeComponent = ({ id }) => {
   const [otp, setOtp] = React.useState("");
   const [loading, setLoading] = React.useState(false);
   const [showContent, setShowContent] = React.useState(false);
   const [disable, setDisable] = React.useState(true);
   const [error, setError] = React.useState(false);
   const [key, setKey] = React.useState(null);
   const [codesData, showCodesData] = React.useState(null)
   const verifyCode = () => {
      if (otp.length < 6) {
         ShowAlert("Please enter a valid code", "error");
         return;
      }
      getSignedURl(true);
   };
   const getSignedURl = (sendCode = false) => {
      if (sendCode) {
         setLoading(true);
      }
      setDisable(true);
      let postData = {
         id: sendCode ? key : id,
      };
      if (sendCode) {
         postData.code = otp;
      }
      axios
         .post(`${process.env.REACT_APP_URL}/servercontent/${sendCode ? "otpVerify" : "validation"}`, postData)
         .then((response) => {
            const responseData = response.data;
            if (responseData.success) {
               if (!sendCode) {
                  setKey(responseData.key);
               }
               if (responseData?.signedURL) {
                  fetchData(responseData.signedURL);
               } else {
                  setShowContent(responseData?.note);
                  showCodesData(responseData.clinicalCodingData)
                  setLoading(false);
               }
            } else {
               ShowAlert("Invalid OTP", "error");
               setLoading(false);
            }

            setDisable(false);
         })
         .catch(() => {
            setDisable(false);
            setError(true);
         });
   };

   useEffect(() => {
      getSignedURl();
      window.addEventListener("keypress", handleKeyPressEvent);
      return () => {
         window.removeEventListener("keypress", handleKeyPressEvent);
      };
   }, []);

   const handleKeyPressEvent = (event) => {
      if (event.keyCode === 13 && event.key === "Enter") {
         const btn = document.getElementById("link-verify-button-content");
         if (btn) {
            btn.click();
         }
      }
   };
   const fetchData = async (urlToFetch) => {
      try {
         const response = await axios.get(urlToFetch);
         if (response?.data?.new) {
            setShowContent(response.data?.new);
         } else {
            setShowContent(response.data);
         }
         setLoading(false);
      } catch (error) {
         setError(true);
      }
   };

   return (
      <div className="h-90">
         {error ? (
            <div className="link-expire-cont">
               <LinkExpire />
            </div>
         ) : codesData ?
            <SharedCodeViewer codesOrdersData={codesData} />
            : showContent ? (
               <TemplateComp content={showContent} />
            ) : (
               <div className=" flex-center h-100">
                  <div className="main-container-verify-shared-link ">
                     <TitleHeader
                        title={"Verify"}
                        subtitle={"We just sent you a 6 digit code on your email and/or sms, please enter below"}
                     />
                     <div className="mt-5 mb-4">
                        <OTPVerify
                           otp={otp}
                           handleOTP={(otp) => {
                              setOtp(otp);
                           }}
                        />
                     </div>

                     <div className="flex-center mt-5">
                        <Button
                           disabled={disable}
                           id="link-verify-button-content"
                           title={loading ? "Verifying..." : "Verify"}
                           className="blue-button-new-app button-middle-section mt-5"
                           onClick={verifyCode}
                        />
                     </div>
                  </div>
               </div>
            )}
      </div>
   );
};

export default CodeComponent;
